import { useState, useEffect } from 'react';
import { InnocodePaymentCardInfo, InnocodePaymentListHorizental } from '@intsoft/innocode-payment';
import { InnocodeChip, InnocodePaginationGroup, InnocodeTextButton, useInnocodeOverlayMenu } from '@intsoft/innocode-core';
import { PaymentType, getPaymentTypeColor, getPaymentTypeLabel } from '../../../resources/utils/paymentUtils';
import { useNavigate } from 'react-router-dom';
import styles from './Subscription.module.css';
import { getSubscriptionStatusColor, getSubscriptionStatusLabel, SubscriptionStatus } from '../../../resources/utils/subscriptionUtils';
import { ZENPAY_SUBSCRIPTION } from '../../../utils/Config';
import { getCookie } from '../../../utils/cookies/cookies';
import axios from "../../../utils/api/axios";
import moment from 'moment';

interface subscriptionInfo {
  subscriptionId: string;
  subscriptionAmount: number;
  subscriptionStatus: SubscriptionStatus;
  subscriptionTitle?: string;
  subscriptionDescription?: string;
  subscriptionStoreName?: string;
  subscriptionStoreBadgeLabel?: string;
  subscriptionThumbnailUrl?: string;
  subscriptionThumbnailBadgeLabel?: string;
}

export default function Page() {
  const [platform, setPlatform] = useState<'web' | 'tablet-vertical' | 'mobile'>('web');
  const navigate = useNavigate();
  const { showOverlayMenu } = useInnocodeOverlayMenu();
  const [enableDeleteMode, setEnableDeleteMode] = useState(false);
  const [subscriptionList, setSubscriptionList] = useState<subscriptionInfo[]>([

  ]);

  // 페이지네이션 상태
  const listSize = 10;
  const [totalPages, setTotalPages] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(0);

  const [selectFilter, setSelectFilter] = useState('');

  const toggleDeleteMode = () => {
    setEnableDeleteMode(!enableDeleteMode);
  };

  const getPlatform = (width: number): 'web' | 'tablet-vertical' | 'mobile' => {
    if (width < 768) return 'mobile';
    if (width < 1440) return 'tablet-vertical';
    return 'web';
  };


  useEffect(() => {
    // 초기 사이즈 설정 
    setPlatform(getPlatform(window.innerWidth));
    // 윈도우 리사이즈 이벤트 핸들러
    const handleResize = () => {
      setPlatform(getPlatform(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);

    // 클린업 함수
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    getSubscriptionList(0);
  }, []);

  // 페이지 이동 핸들러
  const handlePageChange = (page: number) => {
    if (page < 0 || page >= totalPages) return;
    setCurrentPage(page);
  };

  useEffect(() => {
    getSubscriptionList(currentPage);
  }, [currentPage]);

  useEffect(() => {
    getSubscriptionList(currentPage, selectFilter);
  }, [selectFilter]);

  const getSubscriptionList = async (page: number, filter?: string) => {
    try {

      const user = JSON.parse(getCookie("user"));
      const profileList = user.sub_profile;

      //profileList에서 profile_id찾아서 id리스트 만들기
      let profileIds = profileList.map((profile: any) => profile.profile_id);
      console.log('user', user);

      profileIds.push(getCookie("user_id"));
      profileIds = profileIds.join(',');
      console.log('profileIds', profileIds);

      const conditions = [
        { field: "customerId", operator: "IN", value: profileIds },
        { field: "status", operator: "NOT_EQUALS", value: "PENDING" }
      ];

      if (filter) {
        conditions.push({ field: "status", operator: "EQUALS", value: filter });
      }

      const params = {
        page: page,
        size: listSize,
        sortField: ['createdDate'],
        sortOrder: ['desc'],
        operator: "AND",
        conditions
      };


      const res = await axios.post(`${ZENPAY_SUBSCRIPTION}/all`, params);

      const { data, recordsTotal } = res.data.data;

      //data는 paymentHistoryInfo 맞게 가공이 필요
      const transformedSubscriptionList: subscriptionInfo[] = data.map((subscription: any) => {
        const subscriptionDescription = `${subscription.optionName} / ${subscription.optionValue}`;

        return {
          subscriptionId: subscription.subscriptionId,
          subscriptionStatus: subscription.status,
          subscriptionAmount: subscription.paymentAmount,
          subscriptionTitle: subscription.productName,
          // subscriptionDescription: subscriptionDescription,
          subscriptionStoreName: subscription.marketName,
          subscriptionThumbnailUrl: subscription.thumbnailUrl || undefined,
        };
      });

      setSubscriptionList(transformedSubscriptionList);
      setTotalPages(Math.max(1, Math.ceil(recordsTotal / listSize)));

    } catch (error) {
      console.error(error);
    } finally {
    }
  };



  const listItemMgtButtonClick = (e?: React.MouseEvent<HTMLElement>) => {
    if (!e) return;

    console.log(e);
    const target = (e.currentTarget || e.target) as HTMLElement;

    const rect = target?.getBoundingClientRect();

    if (!rect) return;
    console.log("rect: ", rect);
    const x = rect.left;
    const y = rect.bottom + 6;

    // 아이템 상태에 따라 메뉴 항목 동적 구성
    const items = [] as { label: string; onClick: () => void }[];
    items.push(
      { label: '구독 중', onClick: () => { setSelectFilter('ACTIVE'); } },
      { label: '구독 정지', onClick: () => { setSelectFilter('PAUSED'); } },
      { label: '구독 취소', onClick: () => { setSelectFilter('CANCELED'); } },
      { label: '구독 취소 대기', onClick: () => { setSelectFilter('CANCELED_WAIT'); } },
      { label: '환불 대기', onClick: () => { setSelectFilter('REFUND_WAIT'); } },
      { label: '구독 만료', onClick: () => { setSelectFilter('EXPIRED'); } },
      { label: '구독 종료', onClick: () => { setSelectFilter('EOS'); } },

    );

    showOverlayMenu({ position: { x, y }, items });
  }

  return (
    <div className="content-wrapper">
      <div className={styles.pageWrapper}>
        <div className={styles.titleSection}>
          <h3>구독 내역</h3>
        </div>
        <div className={styles.contentSection}>
          {subscriptionList.length === 0 ? (
            <div className={styles.emptyState}> 
              <p className={styles.emptyTitle}>구독 내역이 없습니다</p>
              <p className={styles.emptyDescription}>아직 구독 중인 서비스가 없습니다.</p>
            </div>
          ) : (
            <>
              <InnocodeChip trailingIcon={true} size={"sm"} theme="solid" type="assistive" onClick={(e: any) => {
                listItemMgtButtonClick(e);
              }}>
                <svg {...{ slot: "trailing-icon" }} className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                  <path fill-rule="evenodd" d="M18.425 10.271C19.499 8.967 18.57 7 16.88 7H7.12c-1.69 0-2.618 1.967-1.544 3.271l4.881 5.927a2 2 0 0 0 3.088 0l4.88-5.927Z" clip-rule="evenodd" />
                </svg>

                필터
              </InnocodeChip>
              <div className={styles.dateListWrapper}>
                {subscriptionList.map((subscription) => (
                  <InnocodePaymentListHorizental
                    key={subscription.subscriptionId}
                    className="list_item"
                    size={platform == "web" ? "lg" : "md"}
                    status="default"
                    showPaymentStatus={true}
                    showPaymentDetail={platform == "web" ? false : true}
                    paymentStatus={getSubscriptionStatusLabel(subscription.subscriptionStatus)}
                    paymentStatusColor={getSubscriptionStatusColor(subscription.subscriptionStatus)}
                    leadingThumbnail={true}
                    thumbnailSrc={subscription.subscriptionThumbnailUrl || 'https://storage.innocode.co/api/v1/storage/files/content/c6289fce-c576-489b-9fc1-5235d580184f'}
                    thumbnailAlt="썸네일 이미지"
                    showThumbnailBadge={false}
                    thumbnailBadgeStyle='solid'
                    thumbnailBadgeLabel={subscription.subscriptionThumbnailBadgeLabel || ''}
                    thumbnailSize="sm"
                    showStoreInfo={true}
                    showStoreName={true}
                    showStoreBadge={false}
                    storeName={subscription.subscriptionStoreName || ''}
                    showTitle={true}
                    title={subscription.subscriptionTitle || ''}
                    showDescription={false}
                    description={subscription.subscriptionDescription || ''}
                    showBottomContents={true}
                    showAmount={true}
                    amount={subscription.subscriptionAmount}
                    showPaymentDate={false}
                    onClick={() => {
                      navigate(`/subscription/detail/${subscription.subscriptionId}?enableGobackBar=true`);
                    }}
                    // onButtonClick={() => {
                    //   navigate(`/subscription/detail/${subscription.subscriptionId}?enableGobackBar=true`);
                    // }}
                    onPaymentDetailClick={() => {
                      navigate(`/subscription/detail/${subscription.subscriptionId}?enableGobackBar=true`);
                    }}
                  />
                ))}
              </div>
            </>
          )}

        </div>
        <InnocodePaginationGroup
          width={100}
          totalPages={totalPages}
          currentPage={currentPage + 1}
          onPageChange={(page: number) => {
            handlePageChange(page - 1);
          }}
          onPrevious={() => {
            handlePageChange(currentPage - 1)
          }}
          onNext={() => {
            handlePageChange(currentPage + 1);
          }}
          onFirst={() => {
            handlePageChange(0);
          }}
          onLast={() => {
            handlePageChange(totalPages - 1);
          }}
          showNavigation={true}
          showFirstLast={true}
          showEllipsis={true}
          pageRange={10}
        ></InnocodePaginationGroup>
      </div>
    </div>
  );
}
